import { ApiError } from '@/shared/api/errors'

/**
 * Connectivity check against managerium's `/v1/hello`, resolved via Consul
 * service DNS. This is a different host than lionfish's own backend, so it
 * intentionally bypasses `apiFetch`/`API_BASE` rather than being routed
 * through it.
 */

const MANAGERIUM_HELLO_URL = 'https://managerium.service.consul/v1/hello'

export async function pingManagerium(): Promise<string> {
  const response = await fetch(MANAGERIUM_HELLO_URL, {
    headers: { Accept: 'application/json' },
  })
  const text = await response.text()

  if (!response.ok) {
    throw new ApiError(response.status, response.statusText, text)
  }

  return text
}
